import { CSSProperties, FC } from 'react'
export interface BackgroundImageProps
  extends Pick<
    CSSProperties,
    'backgroundPosition' | 'backgroundSize' | 'backgroundRepeat' | 'flex' | 'height' | 'width'
  > {
  url: string
}

export const BackgroundImage: FC<BackgroundImageProps> = ({
  backgroundPosition = 'center',
  backgroundRepeat = 'no-repeat',
  backgroundSize = 'cover',
  children,
  url,
  ...rest
}) => (
  <div
    style={{
      backgroundImage: `url("${url}")`,
      backgroundPosition,
      backgroundRepeat,
      backgroundSize,
      ...rest,
    }}
  >
    {children}
  </div>
)
